import { Observable } from 'rxjs';
import { UseCase } from '../../base/use-case';
import { TypeMimeModel } from '../../models/academy/type-mime.model';
import { AcademyRepository } from '../../repositories/academy.repository';

export class GetalltypemimeUseCase implements UseCase<void, TypeMimeModel> {
  constructor(private repository: AcademyRepository) {}

  execute(): Observable<TypeMimeModel> {
    return this.repository.getAllTypeMime();
  }
}
